import { render, staticRenderFns } from "./OrderFailure.vue?vue&type=template&id=892cdc9c"
import script from "./OrderFailure.vue?vue&type=script&lang=js"
export * from "./OrderFailure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports